import React from 'react';
import {Icon} from '@/components/atoms';
import {Box, Button, Typography} from '@mui/material';
import {COLOR_CODE} from '@/utils/constants/colors';
import PropTypes from 'prop-types';

const EmptyState = ({
  icon = 'search_off',
  title = 'No data found!',
  description = 'Please try a different filter value',
  buttonText = 'Reset Filters',
  buttonIcon = 'refresh',
  onActionClick,
  customStyle = {},
  hideTitle = false,
  hideDescription = false,
  hideButton = false,
  titleTextStyle = {},
  descriptionTextStyle = {},
  hideIcon = false
}) => {
  return (
    <Box
      data-testid='empty-state-container'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        py: 8,
        border: `1px solid ${COLOR_CODE._333333}`,
        ...customStyle
      }}>
      {!hideIcon && (
        <Icon icon={icon} size='large' sx={{color: COLOR_CODE._616161}} />
      )}
      {!hideTitle && (
        <Typography
          variant='h5'
          sx={{
            color: COLOR_CODE._FFFFFF,
            fontSize: '1.5rem',
            fontWeight: 'bold',
            ...titleTextStyle
          }}>
          {title}
        </Typography>
      )}
      {!hideDescription && (
        <Typography
          variant='body1'
          sx={{
            fontSize: '1rem',
            color: COLOR_CODE._D0D0D0,
            ...descriptionTextStyle
          }}>
          {description}
        </Typography>
      )}
      {onActionClick && !hideButton && (
        <Button
          onClick={onActionClick}
          variant='outlined'
          startIcon={<Icon icon={buttonIcon} size='small' />}
          sx={{
            mt: 2,
            color: COLOR_CODE._3387DF,
            borderColor: COLOR_CODE._3387DF,
            backgroundColor: 'transparent'
          }}>
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  onActionClick: PropTypes.func,
  customStyle: PropTypes.object,
  hideTitle: PropTypes.bool,
  hideDescription: PropTypes.bool,
  hideButton: PropTypes.bool,
  titleTextStyle: PropTypes.object,
  descriptionTextStyle: PropTypes.object,
  hideIcon: PropTypes.bool
};

export default React.memo(EmptyState);
